import React, { ReactNode, useState } from 'react';
import { useStore } from 'react-redux';
import { downloadImage } from '../../../../util/downloadQrcode';
import { ViiisionSuccessSnackbar } from '../../../ViiisionSuccessSnackbar';
import { ViiisionContextMenu } from './ViiisionContextMenu';
import { _topics } from '../../../../store/slices/topicSlice';
import { useAppSelector } from '../../../../store/hooks';

export type QRContextMenuProps = {
	topicId: string;
	children: ReactNode;
};

export const QRContextMenu: React.FC<QRContextMenuProps> = (props) => {
	const { children, topicId } = { ...props };
	const store = useStore();
	const [copySuccess, setCopySuccess] = useState(false);
	const topics = useAppSelector(_topics);
	const selectedTopic = topics[topicId];

	const copyToClipboard = () => {
		// Get the latest state from Redux store at copy time
		const state = store.getState();
		const currentTopic = state.topic.topics[topicId];

		// Try to get organization directly from topic, or via location
		let organization;
		if (currentTopic?.organizationId) {
			organization = state.organization.organizations[currentTopic.organizationId];
		} else if (currentTopic?.locationId) {
			const location = state.location.locations[currentTopic.locationId];
			if (location?.organizationId) {
				organization = state.organization.organizations[location.organizationId];
			}
		}

		const { appSlug } = organization || {};
		const { pageSlug } = currentTopic?.metadata || {};

		const url =
			appSlug && pageSlug
				? `${process.env.REACT_APP_LIIINGO_WEBAPP_URL}/${appSlug}/${pageSlug}`
				: `${process.env.REACT_APP_LIIINGO_WEBAPP_URL}/topic/${topicId}`;

		navigator.clipboard.writeText(url);
		setCopySuccess(true);
	};

	return (
		<>
			<ViiisionContextMenu
				id="editcontextMenu1"
				options={[
					{
						text: 'Copy Link',
						handleClick: copyToClipboard,
					},
					{
						text: 'Download PNG',
						handleClick: () => downloadImage(topicId, selectedTopic.name[0].name, 'png'),
					},
					{
						text: 'Download SVG',
						handleClick: () => downloadImage(topicId, selectedTopic.name[0].name, 'svg'),
					},
				]}
			>
				{children}
			</ViiisionContextMenu>
			<ViiisionSuccessSnackbar
				open={copySuccess}
				text="Link copied successfully"
				onClose={() => setCopySuccess(false)}
			/>
		</>
	);
};
